/**
 * settingsStore — load and save dashboard settings via Supabase.
 *
 * Settings are keyed by org_id (from REACT_APP_ORG env var).
 * Falls back gracefully to localStorage-only mode if Supabase is unavailable.
 *
 * Settings shape stored in the `settings` jsonb column:
 *   indicatorIds  string[]   — ordered selected indicator IDs
 *   enabledIds    string[]   — subset of indicatorIds currently visible
 *   goals         object     — { [indicatorId]: number }
 *   themes        object[]   — [{ id, label, indicatorIds[] }]
 *   gradients     object     — { [indicatorId]: gradientId }
 *   rationales    object     — { [indicatorId]: string }
 *   yearRange     object     — { from: number|null, to: number|null }
 */

import { supabase } from './supabase';

const ORG_ID = process.env.REACT_APP_ORG ?? 'fcp-pilot';

export async function loadSettings() {
  if (!supabase) return null;
  try {
    const { data, error } = await supabase
      .from('dashboard_settings')
      .select('settings')
      .eq('org_id', ORG_ID)
      .single();
    if (error || !data) return null;
    return data.settings ?? null;
  } catch (_) {
    return null;
  }
}

export async function saveSettings(settings) {
  if (!supabase) return;
  try {
    await supabase
      .from('dashboard_settings')
      .upsert({ org_id: ORG_ID, settings, updated_at: new Date().toISOString() });
  } catch (_) {
    // Silently fail — localStorage save already happened
  }
}
